import ReactDOM from 'react-dom'

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback)
  }
}

export const onClientEntry = () => {
  if (typeof window !== 'undefined' && (process.env.GATSBY_ENV === "production")) {
    // Create script element
    const script = document.createElement('script')
    script.innerHTML = `
      window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '6bb5a0bdab863c838a4ecf0000364eec693fa91e', { region: 'eu' });
    `
    
    // Add script to head
    document.head.appendChild(script)
  }
}